import api from "../apiapp";


const documentService = {
    getDocumentSearchPagination: async function (purl) {
      const response = await api.request({
        url: purl,
        method: "GET",
      })
      
      return response.data
    },
    getDocumentSearch: async function (status) {
      var filters = '';
      if(status !== ""){ filters += '&filter[status]='+status; }
        
      const response = await api.request({
        url: "sworn-statements?page[size]=30&include=swornStatementType"+filters,
        method: "GET",
      })
    
      return response.data
    },
    putDocumentStatus: async function (id) {
      const response = await api.request({
        url: "sworn-statements/change-status/"+id,
        method: "POST",
        data: {}
      })
    
      return response.data
    },
    setDocument: async function (model) {
      const response = await api.request({
        url: "sworn-statements/",
        method: "POST",
        data: model
      })
    
      return response.data
    },
    getDocumentById: async function (id) {
      const response = await api.request({
        url: "sworn-statements/"+id,
        method: "GET"
      })
    
      return response.data
    },
    putDocument: async function (id, model) {
      const response = await api.request({
        url: "sworn-statements/"+id,
        method: "PUT",
        data: model
      })
    
      return response.data
    },
}
  
export default documentService;